
import React, { useState } from "react";
import { GSForm, GSSidePanelPage, useFormDataValidation } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";

//import scss
import "./donation-item-form.scss"
import { useNotificationAction, useNotificationBanner, useNotifications } from "../../../../hooks/notificationHooks";
import { getDonationForm } from "../../../../forms/DonationForm";
import { useDispatch, useSelector } from "react-redux";
import { selectRegistrationOrder, updateDonationItemThunk } from "../../../../reducers/registrationOrderSlice";
import { FULFILLED } from "../../../../app/api";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";

//Name the component
const DonationItemForm = (props) => {

  const registrationOrder = useSelector(selectRegistrationOrder)

  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()
  const donationID = searchParams?.get?.("id") ?? ""

  const donation = registrationOrder?.donationOrderItems?.find?.(d => d.id === donationID)

  const [message, setMessage] = useState(donation?.notes ?? "")

  const [context, isValid, setIsValid] = useFormDataValidation({
    initalValid: false,
    setData: (update) => {
      setMessage(update?.notes)
    },
    data: {notes: message}
  })

  const navigate = useGolfstatusNavigate()
  const {filteredNotifications} = useNotifications()

  const notifications = filteredNotifications(["updateDonationItemThunk"])

  useNotificationAction(FULFILLED, notifications, () => {navigate(-1)})

  const save = () => {
    setIsValid(false)
    dispatch(updateDonationItemThunk({...donation, notes: message}))
  }

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Save & Continue",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Donation Message`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formTitle="Donation Message" formSections={getDonationForm(context)}></GSForm>;
  };

  const timeoutAction = () => {
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({notifications, timeoutAction})

  return (
    //name the component tag
    <donation-item-form>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </donation-item-form>
  );
};

//export the new namet
export default DonationItemForm;